(function($) {
    'use strict';

    /**
     * Медиа-альбом
     * @param {Object[]} [albumData] - объект с данными альбома
     * @param {Object} [options] - объект с параметрами
     * @returns {jQuery}
     */
    $.fn.mediaAlbum = function (albumData, options) {
        const defaults = {
            pageSize: 23,
            itemSelector: '.js-media-album-item'
        };

        let settings = $.extend({}, defaults, options);

        let $container = $(this);
        let $pagerBtn = $('.js-show-more-photos');
        let $popup;
        let $loader;

        const $popupTemplate = $('.js-popup-template');

        let currentPage = 1;

        /**
         * Рендер элементов альбома из JSON
         *
         * @param {Object[]} data - массив JSON-объектов с элементами альбома
         * @param {Number} [pageNumber] - номер страницы
         *
         * @return Number - Индекс последнего отображённого элемента
         */
        const renderItems = function (data, pageNumber) {
            currentPage = (typeof pageNumber !== 'undefined' && pageNumber > 1) ? (pageNumber - 1) : 1;

            if (data.length === 0) {
                return;
            }

            let startItemIndex = (pageNumber > 1) ? (currentPage * settings.pageSize) : 0;
            let endItemIndex = (pageNumber > 1) ? (startItemIndex + settings.pageSize) : settings.pageSize;

            for (let i = startItemIndex; i < Math.min(endItemIndex, data.length); i++) {
                $container.append($('<div>', {
                    class: 'media-grid-item',
                    append: $('<a>', {
                        class: 'js-media-album-item',
                        href: data[i].itemUrl,
                        attr: {
                            'data-item-index': i
                        },
                        append: $('<img>', {
                            alt: '',
                            src: data[i].previewUrl,
                            loading: 'lazy',
                            attr: {
                                width: data[i].previewWidth,
                                height: data[i].previewHeight,
                            }
                        })
                    })
                }));
            }

            return endItemIndex;
        };

        /**
         * Открыть попап из шаблона
         */
        const openPopup = function () {
            $popup = $popupTemplate.clone();
            $loader = $popup.find('.js-popup-loader');
            $popup.appendTo('body');

            $('html').css('overflow', 'hidden');

            $popup.on('click', function (event) {
                let $target = $(event.target);

                if ($target.is($popup) || $target.closest('.js-popup-close').length) {
                    closePopup();
                } else if ($target.closest('.js-popup-prev').length) {
                    prevMedia();
                } else if ($target.closest('.js-popup-next').length) {
                    nextMedia();
                }
            });

            if (typeof $.fn.swipe === 'undefined') {
                return;
            }

            $popup.swipe({
                swipe: function (event, direction) {
                    switch (direction) {
                        case 'left':
                            nextMedia();
                            break;

                        case 'right':
                            prevMedia();
                            break;

                        default:
                            break;
                    }
                }
            });
        };

        /**
         * Закрыть попап
         */
        const closePopup = function () {
            $popup.remove();
            $('html').css('overflow', '');
        };

        /**
         * Перейти к предыдущему элементу альбома в попапе
         */
        const prevMedia = function () {
            if ($(document).find($popup).length === 0) {
                return;
            }

            setPopupContentByItemIndex($popup.data('currentIndex') - 1);
        };

        /**
         * Перейти к следующему элементу альбома в попапе
         */
        const nextMedia = function () {
            if ($(document).find($popup).length === 0) {
                return;
            }

            setPopupContentByItemIndex($popup.data('currentIndex') + 1);
        };

        /**
         * Установить контент попапа по индексу элемента альбома
         * @param {Number} index - индекс элемента альбома
         */
        const setPopupContentByItemIndex = function (index) {
            const $popupContent = $popup.find('.js-popup-content');

            if (albumData.length === 0 || $(document).find($popup).length === 0) {
                return;
            }

            index = (index + albumData.length) % albumData.length; // зацикливаем список

            let currentItemData = albumData[index];

            $popup.data('currentIndex', index);

            $popupContent.addClass('loading');

            if ($popup.find('img').length) {
                $popup.find('img').remove();
            }

            $popupContent
                .css({
                    width: '',
                    height: ''
                })
                .append($('<img>', {
                    src: currentItemData.itemUrl,
                    alt: '',
                    loading: 'lazy',
                    attr: {
                        width: currentItemData.itemWidth,
                        height: currentItemData.itemHeight
                    },
                    on: {
                        load: function () {
                            let maxWidth = $popup.width();
                            let maxHeight = $popup.height();
                            let xRatio = currentItemData.itemWidth / maxWidth;
                            let yRatio = currentItemData.itemHeight / maxHeight;
                            let maxRatio = Math.max(xRatio, yRatio);

                            $popupContent.removeClass('loading');

                            if (maxRatio > 1) {
                                $popupContent.css({
                                    width: currentItemData.itemWidth / maxRatio,
                                    height: currentItemData.itemHeight / maxRatio
                                });
                            } else {
                                $popupContent.css({
                                    width: currentItemData.itemWidth,
                                    height: currentItemData.itemHeight
                                });
                            }
                        }
                    }
                }))
                .find('.js-popup-item-count')
                .text((index + 1) + '/' + albumData.length);
        };

        const init = function () {
            let isLoading = false;
            $pagerBtn.on('click', function () {
                if (isLoading === true) {
                    return;
                }

                isLoading = true;

                let $btn = $(this);

                let pageNum = $btn.data('next-page');
                let endItemIndex = renderItems(albumData, pageNum);

                isLoading = false;

                if (endItemIndex >= albumData.length) {
                    $btn.remove();
                    return;
                }

                $btn.data('next-page', ++pageNum);
            });

            // клик по элементу альбома - открытие попапа
            $(document).on('click', settings.itemSelector, function (e) {
                openPopup();
                setPopupContentByItemIndex($(this).data('item-index'));

                return false; // запрещаем переход по ссылке при открытии попапа
            });

            // управление с клавиатуры
            $(document).on('keydown', function(e) {
                if ($(document).find($popup).length) {
                    switch (e.key) {
                        case 'ArrowLeft':
                            prevMedia();
                            break;

                        case 'ArrowRight':
                            nextMedia();
                            break;

                        case ' ':
                            nextMedia();
                            break;

                        case 'Escape':
                            closePopup();
                            break;

                        default:
                            break;
                    }
                }
            });
        };

        init();

        return this;
    };
})(jQuery);
